const Currency = {

    // FIELDS
    "name": "الاسم",
    "short_name": "الاسم القصير",
    "symbol": "الرمز",
    "status": "الحالة",
    "country": "البلد",
    "search": "بحث",

    // PAGE HEADER
    "currency": "العملة",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_short_name": "الرجاء إدخال الاسم القصير",
    "error_symbol": "الرجاء تحديد الرمز",
    "error_status": "الرجاء تحديد الحالة",
    "error_country": "الرجاء تحديد البلد",

    // TABLE HEADER
    "table_name": 'الاسم',
    "table_short_name": 'الاسم القصير',
    "table_symbol": 'الرمز',
    "table_country": "البلد",
    "table_status": "الحالة",

}

export default Currency;